import { useMemo } from "react";

import { FeatureIslandContainer, FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { ReservationSearchHeaderAndTab, SearchResultTable } from "../../_shared";
import * as Model from "../model";
import {
	BasicSearchActionsComposition,
	CsvDownloadPerReservationForReservationSearch,
	CsvDownloadPerStayDateForReservationSearch,
	SearchByDetailConditionsComposition,
} from "./compositions";

type Props = {
	hotelID: string;
};

export const ManagementReservationSearchRequest = ({ hotelID }: Props) => {
	const {
		//
		// readonly
		viewData,
		//
		// searchable
		searchModel,
		// 予約の検索
		onSearchReservationRequestList,
		// 詳細検索のメルマガ配信希望者フラグの変更
		onChangeIsAcceptMailMagazineChecked,
		// 詳細検索の現地決済者フラグの変更
		onChangeIsLocalPaymentChecked,
	} = Model.UseCase.useInitialized({ hotelID });

	/**
	 * 詳細検索セクションの表示制御雨
	 */
	const canShowDetailSearchSection = useMemo(() => {
		return viewData.detailSearch.canShowDetailSearchSection;
	}, [viewData.detailSearch.canShowDetailSearchSection]);

	return (
		<FeatureIslandContainer>
			<ReservationSearchHeaderAndTab hotelID={hotelID} />

			<FeatureIslandMainWithBackGround>
				<div>
					{/* 通常検索セクション */}
					<BasicSearchActionsComposition onSearchReservationRequestList={onSearchReservationRequestList} />

					{/* 絞り込みセクション */}
					{canShowDetailSearchSection && (
						<div className="mt-4 space-y-2">
							{/* 詳細での検索 */}
							<SearchByDetailConditionsComposition
								searchModel={searchModel}
								// 詳細検索のメルマガ配信希望者フラグの変更
								onChangeIsAcceptMailMagazineChecked={onChangeIsAcceptMailMagazineChecked}
								// 詳細検索の現地決済者フラグの変更
								onChangeIsLocalPaymentChecked={onChangeIsLocalPaymentChecked}
							/>
						</div>
					)}

					{/* 検索結果テーブル */}
					<div className="mt-10">
						<SearchResultTable
							rows={viewData.searchResultTableData.rows}
							aboutChildren={
								<div className="hidden tablet:flex tablet:items-center tablet:gap-x-2">
									{/* 予約毎の CSV ダウンロード */}
									<CsvDownloadPerReservationForReservationSearch viewData={viewData} />

									{/* 宿泊毎の CSV ダウンロード */}
									<CsvDownloadPerStayDateForReservationSearch viewData={viewData} />
								</div>
							}
						/>
					</div>
				</div>
			</FeatureIslandMainWithBackGround>
		</FeatureIslandContainer>
	);
};
